/**
 * Templates d'emails transactionnels pour les notifications de statut
 * Ton institutionnel, clair et concis
 * INTERDIT: gains chiffrés, "garanti", promesses de CA
 */

interface EmailTemplate {
  subject: string;
  bodyText: string;
}

interface TemplateParams {
  fullName?: string | null;
}

/**
 * Email de confirmation après envoi du formulaire - COMMERCE
 */
export function formSubmittedCommerce({ fullName }: TemplateParams): EmailTemplate {
  const name = fullName || 'Cher candidat';
  
  return {
    subject: 'TP13 — Votre candidature est bien reçue',
    bodyText: `Bonjour ${name},

Nous avons bien reçu votre candidature en tant que collaborateur commercial TP13.

Que se passe-t-il maintenant ?
• Notre équipe examine votre dossier sous 24 à 72 heures ouvrées
• Vous recevrez un email de confirmation dès que votre candidature sera validée
• Si des documents complémentaires sont nécessaires, nous vous contacterons

En attendant, vous pouvez :
• Préparer vos documents justificatifs (Kbis, RIB professionnel, pièce d'identité)
• Les envoyer à admin@tp13.fr pour accélérer le traitement
• Accéder à votre espace personnel : https://tp13.fr/dashboard

Pour toute question, n'hésitez pas à répondre à cet email.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email de confirmation après envoi du formulaire - AO
 */
export function formSubmittedAO({ fullName }: TemplateParams): EmailTemplate {
  const name = fullName || 'Cher candidat';
  
  return {
    subject: 'TP13 — Votre candidature est bien reçue',
    bodyText: `Bonjour ${name},

Nous avons bien reçu votre candidature en tant qu'apporteur d'affaires TP13.

Que se passe-t-il maintenant ?
• Notre équipe examine votre dossier sous 24 à 72 heures ouvrées
• Vous recevrez un email de confirmation dès que votre candidature sera validée
• Si des documents complémentaires sont nécessaires, nous vous contacterons

En attendant, vous pouvez :
• Préparer vos documents justificatifs (pièce d'identité, RIB, justificatif de domicile)
• Les envoyer à admin@tp13.fr pour accélérer le traitement
• Accéder à votre espace personnel : https://tp13.fr/dashboard

Pour toute question, n'hésitez pas à répondre à cet email.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email de validation pour un collaborateur COMMERCE
 */
export function validatedCommerce({ fullName }: TemplateParams): EmailTemplate {
  const name = fullName || 'Cher collaborateur';
  
  return {
    subject: 'TP13 - Votre candidature est validée',
    bodyText: `Bonjour ${name},

Nous avons le plaisir de vous informer que votre candidature en tant que collaborateur commercial TP13 a été validée.

Prochaines étapes :
• Accédez à votre espace personnel : https://tp13.fr/dashboard
• Complétez votre profil si nécessaire
• Envoyez vos documents administratifs à : admin@tp13.fr
• Répondez à cet email pour toute question

Notre équipe reste à votre disposition pour vous accompagner dans votre démarrage.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email de rejet pour un collaborateur COMMERCE
 */
export function rejectedCommerce({ fullName }: TemplateParams): EmailTemplate {
  const name = fullName || 'Cher candidat';
  
  return {
    subject: 'TP13 - Réponse à votre candidature',
    bodyText: `Bonjour ${name},

Nous vous remercions de l'intérêt que vous portez à TP13.

Après étude de votre candidature en tant que collaborateur commercial, nous ne sommes malheureusement pas en mesure de donner suite à votre demande pour le moment.

Cette décision ne remet pas en cause vos compétences. Nous vous encourageons à postuler à nouveau ultérieurement si votre situation évolue.

Pour toute question, n'hésitez pas à répondre à cet email ou à nous contacter à admin@tp13.fr.

Nous vous souhaitons plein succès dans vos projets professionnels.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email de validation pour un apporteur d'affaires AO
 */
export function validatedAO({ fullName }: TemplateParams): EmailTemplate {
  const name = fullName || 'Cher partenaire';
  
  return {
    subject: 'TP13 - Votre candidature est validée',
    bodyText: `Bonjour ${name},

Nous avons le plaisir de vous informer que votre candidature en tant qu'apporteur d'affaires TP13 a été validée.

Prochaines étapes :
• Accédez à votre espace personnel : https://tp13.fr/dashboard
• Consultez vos opportunités et commissions
• Envoyez vos documents administratifs à : admin@tp13.fr
• Répondez à cet email pour toute question

Notre équipe reste à votre disposition pour vous accompagner dans votre activité.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email de rejet pour un apporteur d'affaires AO
 */
export function rejectedAO({ fullName }: TemplateParams): EmailTemplate {
  const name = fullName || 'Cher candidat';
  
  return {
    subject: 'TP13 - Réponse à votre candidature',
    bodyText: `Bonjour ${name},

Nous vous remercions de l'intérêt que vous portez à TP13.

Après étude de votre candidature en tant qu'apporteur d'affaires, nous ne sommes malheureusement pas en mesure de donner suite à votre demande pour le moment.

Cette décision ne remet pas en cause vos compétences. Nous vous encourageons à postuler à nouveau ultérieurement si votre situation évolue.

Pour toute question, n'hésitez pas à répondre à cet email ou à nous contacter à admin@tp13.fr.

Nous vous souhaitons plein succès dans vos projets professionnels.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email de notification interne à l'admin
 */
export function internalNotification(params: {
  candidateName: string;
  candidateEmail: string;
  role: 'AO' | 'COMMERCE';
  newStatus: 'FORM_SUBMITTED' | 'VALIDATED' | 'REJECTED';
}): EmailTemplate {
  const roleLabel = params.role === 'AO' ? 'Apporteur d\'affaires' : 'Collaborateur commercial';
  const statusLabel = {
    FORM_SUBMITTED: 'Formulaire envoyé',
    VALIDATED: 'Validé',
    REJECTED: 'Refusé'
  }[params.newStatus];

  return {
    subject: `TP13 Admin — Changement de statut : ${params.candidateName}`,
    bodyText: `Notification automatique de changement de statut

Candidat : ${params.candidateName}
Email : ${params.candidateEmail}
Rôle : ${roleLabel}
Nouveau statut : ${statusLabel}
Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Accéder au dashboard admin : https://tp13.fr/admin

---
Notification automatique TP13`
  };
}

/**
 * Email à l'AO quand le statut d'une de ses sociétés recommandées change
 */
export function societeStatusChanged(params: {
  aoName: string;
  societeName: string;
  oldStatus: string;
  newStatus: string;
}): EmailTemplate {
  const statusLabels: Record<string, string> = {
    NOUVEAU: 'Nouveau',
    EN_ATTENTE: 'En attente',
    VALIDE: 'Validé',
    REFUSE: 'Refusé',
    EN_PAUSE: 'En pause',
    ARCHIVE: 'Archivé',
  };

  const oldLabel = statusLabels[params.oldStatus] || params.oldStatus;
  const newLabel = statusLabels[params.newStatus] || params.newStatus;

  return {
    subject: `TP13 — Mise à jour du dossier ${params.societeName}`,
    bodyText: `Bonjour ${params.aoName},

Le statut du dossier "${params.societeName}" a été mis à jour.

Ancien statut : ${oldLabel}
Nouveau statut : ${newLabel}
Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Vous pouvez consulter le détail de vos dossiers dans votre espace personnel :
https://tp13.fr/dashboard/ao/opportunites

Pour toute question, n'hésitez pas à nous contacter à admin@tp13.fr.

Cordialement,
L'équipe TP13

---
TP13 - Plateforme de collaboration commerciale
Email : admin@tp13.fr
Web : https://tp13.fr`
  };
}

/**
 * Email à l'admin quand une nouvelle inscription est créée
 */
export function newSignupAdmin(params: {
  userName: string;
  userEmail: string;
  userPhone?: string | null;
  userCity?: string | null;
  role: 'AO' | 'COMMERCE';
}): EmailTemplate {
  const roleLabel = params.role === 'AO' ? 'Apporteur d\'affaires' : 'Collaborateur commercial';
  
  return {
    subject: `🆕 TP13 Admin — Nouvelle inscription ${roleLabel}`,
    bodyText: `Nouvelle inscription reçue sur TP13

Type : ${roleLabel}
Nom : ${params.userName}
Email : ${params.userEmail}
Téléphone : ${params.userPhone || 'Non renseigné'}
Ville : ${params.userCity || 'Non renseignée'}
Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Statut : Compte créé (NEW)

Action requise : Suivre l'évolution de la candidature dans la console admin
👉 https://tp13.fr/admin/candidatures

---
Notification automatique TP13`
  };
}

/**
 * Email à l'admin quand une nouvelle candidature est soumise
 */
export function newCandidatureAdmin(params: {
  candidateName: string;
  candidateEmail: string;
  candidatePhone?: string | null;
  candidateCity?: string | null;
  role: 'AO' | 'COMMERCE';
}): EmailTemplate {
  const roleLabel = params.role === 'AO' ? 'Apporteur d\'affaires' : 'Collaborateur commercial';
  
  return {
    subject: `📋 TP13 Admin — Candidature soumise ${roleLabel}`,
    bodyText: `Candidature soumise sur TP13

Type : ${roleLabel}
Nom : ${params.candidateName}
Email : ${params.candidateEmail}
Téléphone : ${params.candidatePhone || 'Non renseigné'}
Ville : ${params.candidateCity || 'Non renseignée'}
Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Statut : Formulaire envoyé (FORM_SUBMITTED)

Action requise : Examiner et traiter la candidature dans la console admin
👉 https://tp13.fr/admin/candidatures

---
Notification automatique TP13`
  };
}

/**
 * Email à l'admin quand un nouveau ticket support est créé
 */
export function newTicketAdmin(params: {
  ticketId: number;
  userName: string;
  userEmail: string;
  userPhone?: string | null;
  userCity?: string | null;
  role?: 'AO' | 'COMMERCE' | null;
  category: string;
  priority: string;
  subject: string;
  message: string;
}): EmailTemplate {
  const priorityLabels: Record<string, string> = {
    LOW: 'Basse',
    NORMAL: 'Normale',
    HIGH: 'Haute',
    URGENT: 'Urgente',
  };

  const categoryLabels: Record<string, string> = {
    GENERAL: 'Général',
    TECHNIQUE: 'Technique',
    FACTURATION: 'Facturation',
    COMPTE: 'Compte',
    AUTRE: 'Autre',
  };

  const priorityLabel = priorityLabels[params.priority] || params.priority;
  const categoryLabel = categoryLabels[params.category] || params.category;
  const roleLabel = params.role === 'AO' ? 'Apporteur d\'affaires' : params.role === 'COMMERCE' ? 'Collaborateur commercial' : 'Non renseigné';

  return {
    subject: `🎫 TP13 Admin — Nouveau ticket #${params.ticketId} [${priorityLabel}]`,
    bodyText: `Nouveau ticket support créé sur TP13

Ticket #${params.ticketId}
Utilisateur : ${params.userName}
Email : ${params.userEmail}
Téléphone : ${params.userPhone || 'Non renseigné'}
Ville : ${params.userCity || 'Non renseignée'}
Rôle : ${roleLabel}
Catégorie : ${categoryLabel}
Priorité : ${priorityLabel}
Sujet : ${params.subject}

Message :
${params.message.substring(0, 300)}${params.message.length > 300 ? '...' : ''}

Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Action requise : Répondre au ticket dans la console admin
👉 https://tp13.fr/admin/support

---
Notification automatique TP13`
  };
}

/**
 * Email à l'admin quand un nouveau message est ajouté à un ticket existant
 */
export function newTicketMessageAdmin(params: {
  ticketId: number;
  userName: string;
  userEmail: string;
  userPhone?: string | null;
  userCity?: string | null;
  role?: 'AO' | 'COMMERCE' | null;
  subject: string;
  message: string;
}): EmailTemplate {
  const roleLabel = params.role === 'AO' ? 'Apporteur d\'affaires' : params.role === 'COMMERCE' ? 'Collaborateur commercial' : 'Non renseigné';

  return {
    subject: `💬 TP13 Admin — Nouveau message sur ticket #${params.ticketId}`,
    bodyText: `Nouveau message reçu sur un ticket support

Ticket #${params.ticketId}
Sujet : ${params.subject}
Utilisateur : ${params.userName}
Email : ${params.userEmail}
Téléphone : ${params.userPhone || 'Non renseigné'}
Ville : ${params.userCity || 'Non renseignée'}
Rôle : ${roleLabel}

Message :
${params.message.substring(0, 300)}${params.message.length > 300 ? '...' : ''}

Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Action requise : Répondre au message dans la console admin
👉 https://tp13.fr/admin/support

---
Notification automatique TP13`
  };
}

/**
 * Email à l'admin quand un formulaire externe est reçu (webhook systeme.io)
 */
export function newExternalFormAdmin(params: {
  formType: string;
  userName?: string;
  userEmail?: string;
  userPhone?: string;
  userCity?: string;
  additionalData?: Record<string, unknown>;
}): EmailTemplate {
  const formTypeLabels: Record<string, string> = {
    'ao': 'Apporteur d\'affaires',
    'commerce': 'Collaborateur commercial',
    'contact': 'Contact général',
    'autre': 'Autre',
  };

  const formLabel = formTypeLabels[params.formType.toLowerCase()] || params.formType;

  let additionalInfo = '';
  if (params.additionalData && Object.keys(params.additionalData).length > 0) {
    additionalInfo = '\n\nDonnées supplémentaires :\n';
    for (const [key, value] of Object.entries(params.additionalData)) {
      additionalInfo += `${key} : ${value}\n`;
    }
  }

  return {
    subject: `📥 TP13 Admin — Nouveau formulaire externe : ${formLabel}`,
    bodyText: `Nouveau formulaire externe reçu sur TP13

Type de formulaire : ${formLabel}
Nom : ${params.userName || 'Non renseigné'}
Email : ${params.userEmail || 'Non renseigné'}
Téléphone : ${params.userPhone || 'Non renseigné'}
Ville : ${params.userCity || 'Non renseignée'}${additionalInfo}

Date : ${new Date().toLocaleString('fr-FR', { timeZone: 'Europe/Paris' })}

Action requise : Traiter le formulaire dans la console admin
👉 https://tp13.fr/admin/crm

---
Notification automatique TP13`
  };
}